import { Component, Input } from '@angular/core';
import { MapMarkersTypeEnum } from '@app/core/enums/map/map-markers-type.enum';
import { MapMarker } from '@app/core/model/entities/asset/map-marker';
import { AbstractMapControlComponent } from '@app/shared/components/map/abstract-map-control.component';

@Component({
    selector: 'assets-map-legend-control',
    templateUrl: './assets-map-legend-control.component.html',
    styleUrls: ['./assets-map-legend-control.component.scss'],
    standalone: false
})
export class AssetsMapLegendControlComponent extends AbstractMapControlComponent {
  public MapMarkerType = MapMarkersTypeEnum;
  @Input() public mapMarker: MapMarker;
}
